<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 id="header-text">Global Vehicle Forecast Template</h1>
  <div id="actions-container">
    <button mat-raised-button color="primary" id="confirm-button" class="action-button"
            (click)="exportReport()"
            [disabled]="!selectedGlobalScenario">
      Run Report
    </button>
  </div>
</div>
<div class="d-flex flex-column gap-16 pt-2 pb-2">

  <div class="d-flex gap-8 flex-row justify-content-start">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Start Year</mat-label>
      <mat-select [(ngModel)]="startYear" id="startYear">
        <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>End Year</mat-label>
      <mat-select [(ngModel)]="endYear" id="endYear">
        <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="d-flex gap-8 flex-column">
    <div class="content-height">
      <app-global-scenario-select-component
        [user]="stateService.getUserGmid()"
        [memberScenarioType]="0"
        [displayedMemberColumns]="displayedMemberHeaders"
        (confirmEvent)="onScenarioSelection($event)"></app-global-scenario-select-component>
    </div>

  </div>
</div>
